import { useEffect, useRef } from 'react';
import { AcsButton } from '../components';
import { useI18n } from '../i18n/I18nProvider';
import type { KioskConfig } from './api';

/**
 * Informativa privacy mostrata al visitatore (§8).
 *
 * Il contenuto arriva dal server come testo della versione pubblicata: non
 * viene interpretato come HTML, così un'informativa non può introdurre markup
 * nella pagina (§11.4).
 */
export function PolicyDialog({
  policy,
  onClose,
}: {
  policy: KioskConfig['policy'];
  onClose: () => void;
}) {
  const { t } = useI18n();
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="kiosk-dialog__backdrop" role="presentation" onClick={onClose}>
      <div
        className="kiosk-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={policy.title}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="kiosk-dialog__title">{policy.title}</h2>
        <p className="kiosk-dialog__meta">
          {policy.version} · {policy.language.toUpperCase()}
        </p>
        {/* Testo semplice, mai `dangerouslySetInnerHTML`. */}
        <div className="kiosk-dialog__body">{policy.content}</div>
        <AcsButton ref={closeRef} onClick={onClose}>
          {t.kiosk.closePolicy}
        </AcsButton>
      </div>
    </div>
  );
}
